import { QueryKeys } from "@/constants/Query";
import { useApi } from "@/hooks/useApi";
import axiosInstance from "@/lib/axios";

export interface ShiftStatusResponse {
  isOnShift: boolean;
}

export const useShiftStatus = () => {
  return useApi<ShiftStatusResponse>({
    queryOptions: {
      queryFn: async () => {
        const response = await axiosInstance.get<ShiftStatusResponse>(
          "/providers/shift-status",
        );

        return response.data;
      },
      enabled: true,
      queryKey: QueryKeys.Provider.ShiftStatus.DEFAULT,
    },
  });
};
